
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import sanitizeHtml from 'sanitize-html';
	import aps from '@/HostApp/store/ApsModules/ApsModule';

	@Component({})
	export default class Error404 extends Vue {
		@Prop({ required: true })
		protected localizedLabels!: APS.IError404;

		protected get page404SecondaryText(): string {
			return sanitizeHtml(this.localizedLabels.page404SecondaryText, {
				allowedTags: ['a'],
				allowedAttributes: {
					a: ['href']
				}
			});
		}

		protected get isVueWorkspace(): boolean {
			return aps.navigation.isVueWorkspace;
		}
	}
